// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 2H2V11H11V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 2V11H22V2H13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 13H13V22H22V13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 22V13H2V22H11Z"}}]};

const FrameFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'frame-filled',
    ref,
    icon: element,
  },
));

FrameFilledIcon.displayName = 'FrameFilledIcon';

export default FrameFilledIcon;
